<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="whoisModal" tabindex="-1" role="dialog" aria-labelledby="whoisModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader"> {{ this.domain }} </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
           <div v-if="loading" class="modal-body">
            <div class="loader"></div>
          </div>
          <div v-else class="modal-body">
           <section>
             <div class="row">
               <div class="col-md-6">
                 <h4 class="text-primary">Registrar Details</h4>
                 <div v-if="whoisData.registrar" class="registrar">
                   <b>Id:</b> {{whoisData.registrar.id ? whoisData.registrar.id : ''}} <br>
                   <b>Name:</b> {{whoisData.registrar.name ? whoisData.registrar.name : ''}} <br>
                   <b>Email:</b> {{whoisData.registrar.email ? whoisData.registrar.email : ''}} <br>
                   <b>Phone#:</b> {{whoisData.registrar.phone ? whoisData.registrar.phone : ''}} <br>
                   <b>Url:</b> {{whoisData.registrar.url ? whoisData.registrar.url : ''}} <br>
                 </div>
               </div>
               <div class="col-md-6">
                   <h4 class="text-primary">Name Servers</h4>
                   <ul >
                       <li v-for=" (row, index) of whoisData.nameserver " :key="index">{{row}}</li>
                   </ul>
               </div>
             </div>
           </section>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {db} from "@/firebase/init"
import moment from 'moment'
import swal from "sweetalert2";
import _ from "lodash";

export default {
  name: "psiModal",
  data () {
    return {
      domain: '',
      loading: false,
      whoisData: {}
    }
  },
  computed:{

  },
  methods: {
    async load (domain) {
        this.domain=domain
      $('#whoisModal').modal('show');
      this.loading=true;
      const response=await this.getWhoIsInformation();
      this.whoisData=response.data.data
      this.loading=false;

    },
    async getWhoIsInformation(){
    try {
        this.loading=true
        const data=await  this.$http.post(`/utilities/whois`, {
          grant_type: 'token',
          domain: this.domain
        })

        this.loading=false;
              return data;
            } catch (e) {

              this.loading=false;
              console.log(e.toString());
              console.log('Error in creating psi');
              swal({
                title: "Error",
                text: e.response.data.message,
                type: "error",
              });
            }
    }
  }
}
</script>

<style scoped>
.row.macro {
  padding: 10px;
  margin-bottom: 2px;
  border: 1px solid #9b9696;
}
.registrar{
    margin-left: 30px;
}
</style>
